import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Broadcast from './icon-broadcast.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Broadcast {...validProps} />;
}
SvgComponent.iconName = 'broadcast';

export const BroadcastIcon = svgIconWrapper(SvgComponent);
